import React, {Component} from 'react';
import Logo from "../elements/Logo";
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';

import NetworkList from '../elements/NetworkList';
import Loader from './Loader';
//import BlurImageLoader from '../elements/BlurImageLoader';

import {Pages, contactNetworks} from '../common/vars';

import '../../styles/components/menu.css';

import {changeVisibility, toggleLoader} from '../reducers/MenuReducer';
import {hideProject} from '../reducers/PortfolioReducer';
import SvgImageLoader from '../elements/SvgImageLoader';

class Menu extends Component {

  socialNetworks = contactNetworks;

  menu = null;


  /*
   // Debería actualizar la vista, true/false
   shouldComponentUpdate(nextProps, nextState) {
   if (this.props.menu.isOpen !== nextProps.menu.isOpen) {
   this.props.menu.isOpen = nextProps.menu.isOpen;
   //return false;
   }

   return true;
   }*/


  /*
   // Listener para cambios de variables
   componentDidUpdate(prevProps, prevState) {
   if (this.props.menu.isOpen !== prevProps.menu.isOpen) {
   //console.log('asdf');
   }
   }
   */

  render() {
    return (
      <div className={'menu' + (this.props.menu.menuIsOpen ? ' menu--show' : ' ') + (this.props.location.pathname === '/' ? ' menu--dark' : '')} ref={(e) => this.menu = e}>
        <div className="menu__top"></div>
        <div className="menu__middle"
             onClick={() => this.props.dispatch(changeVisibility())}>
          <div className="menu__toggle"></div>
        </div>
        <div className="menu__bottom">
          <Logo className="logo--light"/>
        </div>
        <div className="menu__container">
          <div className="menu__bg">
            {Pages.map((option, i) => {
              return (<SvgImageLoader
                svg={option.svg}
                preview={option.thumbnail}
                image={option.img}
                key={i}
                dataId={i}
                className="menu__bg-img"
                alt={option.name}
              />)
            })}

          </div>
          <div className="menu__center">
            <div className="menu__menu">
              <nav className="menu__list">
                {Pages.map((option, i) => {
                  if (option.url.indexOf('http') === -1) {
                    return (<Link to={option.url} className="menu__list-element" data-id={i}
                                  key={'mle' + i}
                                  onMouseOver={(e) => this.changeBackground(e)}
                                  onMouseOut={(e) => this.removeBackground(e)}
                                  onClick={() => {
                                    this.linkClicked(false)
                                  }}>
                      <div className="menu__list-text" key={'mlet' + i}>{option.name}</div>
                    </Link>)
                  } else {
                    return (<a href={option.url} className="menu__list-element" data-id={i}
                               key={'mle' + i}
                               onMouseOver={(e) => this.changeBackground(e)}
                               onMouseOut={(e) => this.removeBackground(e)}
                               onClick={() => {
                                 this.linkClicked(true)
                               }}>
                      <div className="menu__list-text" key={'mlet' + i}>{option.name}</div>
                    </a>)
                  }
                })}
              </nav>
            </div>
            <div className="menu__contact">
              <div className="menu__contact-element menu__contact-element--address">
                <h4 className="menu__contact-title">My Office</h4>
                <address className="menu__contact-content">
                  Bilbao-Galdakao<br/>
                  Errepidea 10 3rd<br/>
                  48004 Bilbao<br/>
                  Bizkaia
                </address>
              </div>
              <div className="menu__contact-element menu__contact-element--methods">
                <h4 className="menu__contact-title">SAY HI!</h4>
                <address className="menu__contact-content">
                  <span>Email:</span><br/>
                  <a href="mailto:ander@murias.nl">ander@murias.nl</a><br/>
                  <span>Skype:</span><br/>
                  <a href="skype:andermues?userinfo">@andermues</a>
                </address>
              </div>
              <div className="menu__contact-element menu__contact-element--networks">
                <h4 className="menu__contact-title">Social</h4>
                <NetworkList networks={this.socialNetworks} className="network-list--left"/>
              </div>
            </div>
          </div>
        </div>
        <Loader visible={this.props.menu.loaderIsVisible}/>
      </div>
    );
  }

  linkClicked(showLoader) {
    document.getElementsByClassName('layout-main__container')[0].scrollTop = 0;
    if (showLoader) {
      this.props.dispatch(toggleLoader());
    } else {
      this.props.dispatch(changeVisibility());
    }
    this.props.dispatch(hideProject());
    //this.menu.classList.toggle('menu--show');
  }

  changeBackground(e) {
    const id = e.target.getAttribute('data-id');
    document.querySelectorAll('.menu__bg-img[data-id="' + id + '"]')[0].classList.add('menu__bg-img--show');
  }

  removeBackground(e) {
    const id = e.target.getAttribute('data-id');
    document.querySelectorAll('.menu__bg-img[data-id="' + id + '"]')[0].classList.remove('menu__bg-img--show');
  }

}

const mapStateToProps = state => {
  return {
    menu: state.menu,
    portfolio: state.portfolio,
  }
};

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/js/components/Menu.js